/* @flow */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

function formatName(options) {
  options = options || {};
  var names = [];

  if (options.firstName && !options.firstName.trim().isEmpty()) {
    var firstName = options.firstName.trim().toTitleCase();
    if (firstName.indexOf(". ") !== -1) {
      firstName = firstName.replace(". ", ".");
    }
    if (firstName.indexOf("-") !== -1) {
      var firstNames = firstName.split("-");
      firstName = firstNames[0] + "-" + firstNames[1].toLowerCase();
    }
    names.push(firstName);
  }

  // last name
  if (options.lastName && !options.lastName.trim().isEmpty()) {
    names.push(options.lastName.trim().toUpperCase());
  }

  return names.join(" ");
}


function sortAuthors(authors) {
  authors.sort(function (a, b) {
    if (a.lastName === b.lastName) {
      return a.firstName > b.firstName ? 1 : -1;
    } else {
      return a.lastName > b.lastName ? 1 : -1;
    }
  });
  return authors;
}

export default class AbstractList extends Component {
  render() {
    let curSubspecialty = "";
    let abstractList = this.props.abstracts.map(function (abstract) {
      let list = [];

      if (curSubspecialty !== abstract.reviewSubspecialty) {
        curSubspecialty = abstract.reviewSubspecialty;
        list.push(<div><p><font size="5" color="red"><b>{ curSubspecialty }</b></font></p><p>&nbsp;</p></div>);
      }

      if (abstract.finalPresentation === 'Poster') {
        list.push(<span><b>Poster No.: {abstract.venueCode}-{abstract.panelId}</b><br/></span>);
      }

      list.push(<span><font color="blue">{ ReactHtmlParser(abstract.title) }</font><br/></span>);
      list.push(<span>First Author: {formatName(abstract.authors[0])}<br/></span>);

      if (abstract.authors.length > 1) {
        let coAuthors = "";
        let authors = abstract.authors.slice(0);
        authors.shift();

        authors = sortAuthors(authors);
        if (authors.length > 0) {
          let names = [];
          authors.forEach(function (author) {
            names.push(formatName(author));
          });
          coAuthors = names.join(", ");
        }
        if (coAuthors !== "") {
          list.push(<span>Co-Author(s): {coAuthors}<br/></span>);
        }
      }

      list.push(<p>&nbsp;</p>);

      return list;
    });

    return (
      <div className="AbstractList">
        {abstractList}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/abstractList.js
 **/